import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Calibration_Interface } from 'src/app/Interface/Calibration_Interface';
import { Certificate_Asli_Interface } from 'src/app/Interface/Certificate_Asli_Interface';
import { Certificate_Interface } from 'src/app/Interface/Certificate_Interface';
import { Certifivate_Delivery_Interface } from 'src/app/Interface/Certifivate_Delivery_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CertificateService {

constructor(private http:HttpClient) { }

GetBargasb(
  Token:String,
  StartSearchDate:String,
  EndSearchDate:String,
  Customer:String,
  Device:String
  ):Observable<Array<Certificate_Interface>>{
  return this.http.get(environment.BaseUrl
    + "Daro/Certificate/GetBargasb?token="+Token
    +"&Customer="+Customer
    +"&Device="+Device
    +"&StartSearchDate="+StartSearchDate
    +"&EndSearchDate="+EndSearchDate).pipe(
    map(data=>{
      return data as Array<Certificate_Interface>
    })
  )
}

GetAsli( Token:String):Observable<Array<Certificate_Asli_Interface>>{
  return this.http.get(environment.BaseUrl
    + "Daro/Certificate/GetAsli?token="+Token).pipe(
    map(data=>{
      return data as Array<Certificate_Asli_Interface>
    })
  )
}


GetDeliveryCertificateSearch(Token:String,code:String):Observable<Array<Calibration_Interface>>{
  return this.http.get(environment.BaseUrl
    + "Daro/Certificate/GetDeliveryCertificateSearch?token="+Token
    +"&code="+code).pipe(
    map(data=>{
      return data as Array<Calibration_Interface>
    })
  )
}

GetDelivery(Token:String):Observable<Array<Certifivate_Delivery_Interface>>{
  return this.http.get(environment.BaseUrl
    + "Daro/Certificate/GetDelivery?token="+Token).pipe(
    map(data=>{
      return data as Array<Certifivate_Delivery_Interface>
    })
  )
}

GetDeliveryCertificateShowForm(Token:String,id:Number):Observable<any>{
  return this.http.get(environment.BaseUrl
    + "Daro/Certificate/GetDeliveryCertificateShowForm?token="+Token+"&id="+id).pipe(
    map(data=>{
      return data as any
    })
  )
}


GetDetailCount(Token:String):Observable<any>{
  return this.http.get(environment.BaseUrl
    + "Daro/Certificate/GetDetailCount?token="+Token).pipe(
    map(data=>{
      return data as any
    })
  )
}

uploadFile(body,id){

  const headers = new HttpHeaders().set('content-type', 'application/json');
  return this.http.post(environment.BaseUrl + "Daro/Certificate/Upload?id="+id,body).pipe(
    map(data=>{
      console.log(data);

      return data as Array<Certificate_Interface>
    })
  )

}

AddCertificate(
  model: Array<Certificate_Interface>,
  customer_id:Number,
  expert_Calibration_id:Number,
  tedad_bargashti:number,
  elat:number,
  Token:String)
  :Observable<Array<Certificate_Interface>>{
  const headers = new HttpHeaders().set('content-type', 'application/json');

  var body:Array<any>=[]
  for(let item of model)
  {
    body.push({
      id:item.id,
      customer_id:customer_id,
      expert_Calibration_id:expert_Calibration_id,
      create_username:Token,
      filename:item.filename,
      device_code:item.device_code,
      certificate_no:item.certificate_no,
      calibration_date:item.calibration_date,
      recal_date:item.recal_date,
      tedad_bargashti:tedad_bargashti,
      elat:elat
    })
  }

  console.log(body);


    return this.http.post(environment.BaseUrl + "Daro/Certificate/Add",body,{headers}).pipe(
      map(data=>{
        return data as Array<Certificate_Interface>
      })
    )

}


PostDelivery(
  model: Array<Calibration_Interface>,
  dsc:string,
  Token:String)
  :Observable<Array<Certificate_Interface>>{
  const headers = new HttpHeaders().set('content-type', 'application/json');

  var Certificate_Detail:Array<any>=[]
  for(let item of model)
  {
    Certificate_Detail.push(item.id)
  }

  var body={
    Certificate_Detail:Certificate_Detail,
    Dsc:dsc,
    Token:Token
  }


    return this.http.post(environment.BaseUrl + "Daro/Certificate/Delivery",body,{headers}).pipe(
      map(data=>{
        return data as Array<Certificate_Interface>
      })
    )

}

DeliveryPayed(id:number,Token:String)
  :Observable<any>{
  const headers = new HttpHeaders().set('content-type', 'application/json');

  var body={
    dsc:Token,
    id:id
  }


    return this.http.post(environment.BaseUrl + "Daro/Certificate/DeliveryPayed",body,{headers}).pipe(
      map(data=>{
        return data as any
      })
    )

}

}
